import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { iconAttributes } from '@/utils/icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserMobile',
  setup(__props) {

const attrs = iconAttributes({ width: 44, height: 44 });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _normalizeProps(_guardReactiveProps(_unref(attrs))), _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "22",
      cy: "22",
      r: "22",
      fill: "transparent"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "22",
      cy: "15.125",
      r: "4.5",
      fill: "transparent",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.375 31.4286C13.375 26.7736 17.1486 23 21.8036 23H22.1964C26.8514 23 30.625 26.7736 30.625 31.4286C30.625 31.7442 30.3692 32 30.0536 32H13.9464C13.6308 32 13.375 31.7442 13.375 31.4286Z",
      fill: "transparent",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1)
  ]), 16))
}
}

})